import api from "../service/consultarProtocolo.service";
import * as types from "./consultarProtocolo.actionTypes";
import formActions from "@common/store/form/form.actions";
import { takeEvery, call, put, select } from "redux-saga/effects";
import consultarProtocoloActions from "./consultarProtocolo.actions";
import consultarProtocoloSelector from "./consultarProtocolo.selectors";

export default workSaga;

function* workSaga() {
  yield takeEvery(types.PESQUISAR_CONSULTAR_PROTOCOLO_MODAL, pesquisarConsultarProtocoloModal);
  yield takeEvery(types.ABRIR_CONSULTAR_PROTOCOLO, abrirConsultarProtocolo);
  yield takeEvery(types.PESQUISAR_CONSULTAR_PROTOCOLO, pesquisarConsultarProtocolo);
  yield takeEvery(types.VIEW_ANALISE_CONSULTAR_PROTOCOLO, viewAnaliseConsultarProtocolo);
  yield takeEvery(types.MODAL_VIEW_ANALISE, modalViewAnalise);
}

function* pesquisarConsultarProtocoloModal(action){
  const { payload } = action;
  const state = yield select(consultarProtocoloSelector.consultarProtocolo);

  try {
    if (state?.tokenRecaptchaModal != "" && state?.tokenRecaptchaModal != undefined) {
      var result = yield call(api.consultarProtocoloByCpfCnpj, payload, {
        headers: { tokenRecaptcha: state?.tokenRecaptchaModal}
      });

    yield put(consultarProtocoloActions.toggleModalConsultarProtocolo());

    if (result.data.length > 1) {
      yield put(consultarProtocoloActions.setConsultarProtocoloGridPesquisa(result.data));
      yield put(formActions.gridReload());
    } else {
      const documento = result.data[0];

      yield put(consultarProtocoloActions.setHeaderConsultarProtocolo(documento));

      const resultConsulta = yield call(api.consultarProtocoloAnalise, documento.NumeroProtocolo);
      yield put(consultarProtocoloActions.setGridConsultarProtocolo(resultConsulta.data));
      yield put(formActions.gridReload());
      yield put(consultarProtocoloActions.setConsultarProtocoloGridPesquisa([]));
    }
  }else{
    _alert.warning("É necessário validar o ReCaptcha.");
    yield resetRecaptchaModal();
  }
  }
  catch {
    yield resetRecaptchaModal();
    yield put(formActions.redirect('redeSIM.consultarProtocolo'));
    yield put(consultarProtocoloActions.toggleModalConsultarProtocolo());
    yield put(consultarProtocoloActions.limpaGridsConsultarProtocolo());
  }
}

function* abrirConsultarProtocolo(action){
  const { payload } = action;

  try {
    yield put(consultarProtocoloActions.setHeaderConsultarProtocolo(payload));

    const result = yield call(api.consultarProtocoloAnalise, payload.NumeroProtocolo);
    yield put(consultarProtocoloActions.setConsultarProtocoloGridPesquisa([]));
    yield put(consultarProtocoloActions.setGridConsultarProtocolo(result.data));
    yield put(formActions.gridReload());
  }
  catch {
    yield put(formActions.redirect('redeSIM.consultarProtocolo'));
    yield put(consultarProtocoloActions.limpaGridsConsultarProtocolo());
  }
}

function* pesquisarConsultarProtocolo(action){
  const { payload } = action;

  try {
    const state = yield select(consultarProtocoloSelector.consultarProtocolo);

    if (state?.tokenRecaptcha != "" && state?.tokenRecaptcha != undefined) {
      var result = yield call(api.consultarProtocoloByProtocolo, payload, {
        headers: { tokenRecaptcha: state?.tokenRecaptcha}
      });

      yield put(consultarProtocoloActions.setHeaderConsultarProtocolo(payload));

      yield put(consultarProtocoloActions.setTokenRecaptcha());
      if (result.data.length > 1) {
        yield put(consultarProtocoloActions.setConsultarProtocoloGridPesquisa(result.data));
      } else {
        const documento = result.data[0];
        yield put(consultarProtocoloActions.setHeaderConsultarProtocolo(documento));
        const resultConsulta = yield call(api.consultarProtocoloAnalise, documento.NumeroProtocolo);
        yield put(consultarProtocoloActions.setGridConsultarProtocolo(resultConsulta.data));
        yield put(consultarProtocoloActions.setConsultarProtocoloGridPesquisa([]));
      }
      yield put(formActions.gridReload());
    } else {
      _alert.warning("É necessário validar o ReCaptcha.");
      yield resetRecaptcha();
      yield put(formActions.redirect('redeSIM.consultarProtocolo'));
    }
  }
  catch  {
    yield resetRecaptcha();
    yield put(formActions.redirect('redeSIM.consultarProtocolo'));
    yield put(consultarProtocoloActions.setGridConsultarProtocolo([]));
    yield put(consultarProtocoloActions.setConsultarProtocoloGridPesquisa([]));
  }

}

function* resetRecaptcha() {
  const state = yield select(consultarProtocoloSelector.consultarProtocolo);
  if (state?.recaptchaResetRef)
    state.recaptchaResetRef.call();
}

function* resetRecaptchaModal() {
  const state = yield select(consultarProtocoloSelector.consultarProtocolo);
  if (state?.recaptchaResetRefModal)
    state.recaptchaResetRefModal.call();
}

function* viewAnaliseConsultarProtocolo(action){
  const { payload } = action;

  try {
    const result = yield call(api.ConsultaProtocoloDadosAnalise, payload.IdAnaliseOrgao);

    yield put(consultarProtocoloActions.setViewAnalise(result.data));
    yield put(consultarProtocoloActions.toggleModalViewAnalise());
  }
  catch {
    yield put(consultarProtocoloActions.setGridConsultarProtocolo([]));
    yield put(consultarProtocoloActions.setConsultarProtocoloGridPesquisa([]));
  }
}

function* modalViewAnalise()
{
  yield put(consultarProtocoloActions.toggleModalViewAnalise());
  yield put(formActions.gridReload());
}


